import {gsap} from "gsap";
import {SplitText} from "./SplitText.js";

export function heroLayerAnimation(layerName, lottieName){
    let tl = gsap.timeline();
    const heroText = new SplitText(`.${layerName} .is--hero-text`, { type: "words" });
    let heroWordsFirst = heroText.words.slice(0,3);
    let heroWordsSecond = heroText.words.slice(3);
    tl.from(heroWordsFirst, {
        duration: 0.5,
        opacity: 0,
        x: 40,
        //transformOrigin: "0% 50% -50",
        ease: "back",
        stagger: 0.05
    });
    tl.call(() => Webflow.require('lottie').lottie.getRegisteredAnimations().find(animation => animation.fileName.includes(lottieName)).play(), null,"<0.05");
    tl.from(heroWordsSecond, {
        duration: 1,
        opacity: 0,
        x: 40,
        //transformOrigin: "0% 50% -50",
        ease: "back",
        stagger: 0.05
    }, "<")
    tl.fromTo(`.${layerName} .hero-button`, {
            duration: 1,
            opacity: 0,
            x: -40,
            ease: "back",
        },
        {
            opacity: 1,
            x: 0,
            ease: "back",
            delay: 1
        }, "<");
    tl.fromTo(`.${layerName} .hero-illu`, {
            duration: 1,
            opacity: 0,
            x: 40,
            ease: "back",

        },
        {
            opacity: 1,
            x: 0,
            ease: "back",
            stagger: 0.1
        }, "<");
    return tl;
}

export function heroMasterAnimation() {
    const maintl = gsap.timeline();
    maintl.to(".hero-layer.is--layer-1", {
        autoAlpha: 1,
        duration: 0,
        ease: "back"
    });
    maintl.add(heroLayerAnimation("is--layer-1", "wayin-hand-01"));
    maintl.to(".hero-layer.is--layer-1", {
        autoAlpha: 0,
        duration: 1,
        ease: "back"
    },"+=2.5");
    maintl.to(".hero-layer.is--layer-2", {
        autoAlpha: 1,
        duration: 0,
        ease: "back"
    });
    maintl.add(heroLayerAnimation("is--layer-2", "wayin-hand-02"));
}